<template>
    <b-modal
        id="copy-slu-module"
        ref="copy-slu-module"
        size="md"
        :title="$t('slu_dashboard.copy_module')"
        modal-class="apprentice-default-modal copy-slu-module"
        :ok-title="$t('common.copy')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="load"
        @ok="onOk">
        <div class="copy-slu-module">
            <b-form-group
                :label="$t('slu_dashboard.cohort_where_the_module_comes_from')"
                label-for="slu-cohort-select">
                <design-2021-apprentice-multiselect-component
                    class="slu-cohort-select"
                    id="slu-cohort-select"
                    v-model="selectedCohort"
                    label="name"
                    :options="cohorts"
                    :multiple-select="false"
                    :allow-empty="false"></design-2021-apprentice-multiselect-component>
            </b-form-group>
            <div v-if="selectedCohort">
                <b-form-group
                    :label="$t('slu_dashboard.module_to_copy')"
                    label-for="slu-module-select">
                    <design-2021-apprentice-multiselect-component
                        class="apprentice-select slu-module-select"
                        id="slu-cohort-select"
                        v-model="selectedModule"
                        label="name"
                        :options="selectedCohort.modules"
                        :multiple-select="false"
                        :allow-empty="false"></design-2021-apprentice-multiselect-component>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-copy-slu-module-modal-component',
    props: ['sluCohortIn'],
    data() {
        return {
            cohorts: [],
            selectedCohort: null,
            selectedModule: null,
        };
    },
    methods: {
        onOk() {
            let formData = new FormData();
            formData.append('cohortId', this.sluCohortIn.id);
            formData.append('moduleId', this.selectedModule.id);
            this.alert.saving();
            const headers = { 'Content-Type': 'multipart/form-data' };
            axios.post(this.routes.sluModuleCopy(), formData, { headers: headers }).then(
                (response) => {
                    this.$emit('updateModules', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        load() {
            axios.get(this.routes.sluCohortsForCopy(this.sluCohortIn.slu_course_id)).then(
                (response) => {
                    this.cohorts = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
